export type Obj<T = string> = Record<string, T>;

interface Base {
  [key: string]: Obj<string>;
}

interface Options {
  QHCPSpecialty: Obj;
  SpecialSubClasses: Base;
}

export const physicianOptions: Options = {
  QHCPSpecialty: {
    //    'Aerospace Medicine': '2',
    Allergy: '3',
    Anesthesiology: '4',
    Cardiology: '6',
    Dermatology: '10',
    'Emergency Medicine': '12',
    Endocrinology: '13',
    Gastroenterology: '15',
    'General Practice': '16',
    Hematology: '18',
    'Infectious Disease': '23',
    'Internal Medicine': '24',
    Nephrology: '28',
    Neurology: '29',
    OBGYN: '35',
    Oncology: '37',
    Ophthalmology: '38',
    Orthopedics: '39',
    Otolaryngology: '40',
    Pediatrics: '45',
    Psychiatry: '50',
    'Pulmonary Medicine': '52',
    Radiology: '53',
    Rheumatology: '55',
    Surgery: '58',
    Urology: '61',
  },
  SpecialSubClasses: {
    '6': {
      'General Cardiologist': '1',
      'Non-Invasive Cardiologist': '2',
      'Invasive, Non-Interventional Cardiologist': '3',
      'Interventional Cardiologist': '4',
      'Pediatric Cardiologist': '6',
    },
    '37': {
      'Medical Oncologist': '1',
      'Hematologist - Oncologist': '2',
      'Radiation Oncologist': '3',
      'Surgical Oncologist': '4',
      'Gynecological Oncologist': '5',
      'Pediatric Oncologist': '6',
    },
    '45': {
      'Pediatric Allergist': '7',
      'Pediatric Cardiology': '8',
      'Pediatric Critical Care Medicine': '9',
      'Pediatric Emergency Medicine': '10',
      'Pediatric Endocrinology': '11',
      'Pediatric Gastroenterology': '12',
      'Pediatric Hematology-Oncology': '13',
      'Pediatric Infectious Diseases': '14',
      'Pediatric Nephrology': '15',
      'Pediatric Neurology': '16',
      'Pediatric Ophthalmology': '17',
      'Pediatric Otolaryngology': '18',
      'pediatric Pulmonology': '19',
      'Pediatric Radiology': '20',
      'Pediatric Rheumatology': '21',
      'Pediatric Sports Medicine': '22',
      'Pediatric Urology': '23',
      'Pediatric Sleep Medicine': '24',
    },
    '58': {
      'General Surgery': '6',
      'Orthopedic Surgery': '14',
      'Plastic Surgery': '17',
    },
  },
};
